import { create, StoreApi, UseBoundStore } from 'zustand'

import { BeforeInstallPromptEvent } from '@/types/global'

interface PwaStoreState {
  promptEvent: null | BeforeInstallPromptEvent
  isWaitingForBeforeInstall: boolean
  isInstalling: boolean
  isInstallableByPrompt: boolean
}

interface PwaStoreActions {
  setPromptEvent: (_event: BeforeInstallPromptEvent) => void
  clearPromptEvent: () => void
  setIsWaitingForBeforeInstall: (_value: boolean) => void
  setIsInstalling: (_value: boolean) => void
  setIsInstallableByPrompt: (_value: boolean) => void
  reset: () => void
}

type PwaStore = PwaStoreState & PwaStoreActions

const initialState: PwaStoreState = {
  promptEvent: null,
  isWaitingForBeforeInstall: true,
  isInstalling: false,
  isInstallableByPrompt: false,
}

const usePwaStore: UseBoundStore<StoreApi<PwaStore>> = create((set) => ({
  ...initialState,

  setPromptEvent: (newEvent: BeforeInstallPromptEvent) => {
    set((state) => ({
      ...state,
      promptEvent: newEvent,
    }))
  },

  clearPromptEvent: () => {
    set((state) => ({
      ...state,
      promptEvent: null,
    }))
  },

  setIsWaitingForBeforeInstall: (value: boolean) => {
    set((state) => ({
      ...state,
      isWaitingForBeforeInstall: value,
    }))
  },

  setIsInstalling: (value: boolean) => {
    set((state) => ({
      ...state,
      isInstalling: value,
    }))
  },

  setIsInstallableByPrompt: (value: boolean) => {
    set((state) => ({
      ...state,
      isInstallableByPrompt: value,
    }))
  },

  reset: () => {
    set(initialState)
  },
}))

export { usePwaStore }
